import React from 'react';
import OmniHistoriesMessageBox from 'components/omni-channel-chat-histories/OmniHistoriesMessageBox';
import AIAgentChatHeader from './AIAgentChatHeader';
import { twMerge } from 'tailwind-merge';
import AIAgentChatIntervention from '../AIAgentChatIntervention';
import { ChatSessionDto } from 'types';
import { CHAT_STATUS } from 'utils';

type Props = {
  chatSession: ChatSessionDto;
  isIntervention: boolean;
};
const AIAgentChat: React.FC<Props> = ({ chatSession, isIntervention }) => {
  return (
    <div className='flex h-full w-full flex-col'>
      <div>
        <AIAgentChatHeader chatSession={chatSession} />
      </div>
      <div
        className={twMerge(
          'flex flex-col bg-[#06A77D] transition-all',
          isIntervention && chatSession.status === CHAT_STATUS.PROCESSING
            ? 'h-[calc(100vh-294px)]'
            : 'h-[calc(100vh-242px)]'
        )}
      >
        <OmniHistoriesMessageBox />
      </div>
      {isIntervention && chatSession.status === CHAT_STATUS.PROCESSING && (
        <div className='flex h-13 w-full items-center justify-center'>
          <AIAgentChatIntervention chatSession={chatSession} chatSessionId={chatSession.chatSessionId} />
        </div>
      )}
    </div>
  );
};
export default AIAgentChat;
